export const SESSION_STORAGE_KEYS = {
  AUTH_FLOW: 'auth_flow',
  ORG_ID: 'oid',
  DIRECT_LOGIN: 'direct_login',
  INVITATION_ID: 'invitation_id',
  REDIRECT_TO: 'redirectTo',
  CREATE_INVITATION_TOKEN: 'createInvitationTkn'
};

export const LOCAL_STORAGE_KEYS = {
  LAST_VIEW_MAIN_PAGE: 'last_view_main_page',
  LAST_PROVIDER_NAME: 'lastProviderName',
  LAST_LOCATION: 'lastLocation'
};
